const event_tickets = {
  id: 'Ticket ID',
  ticket_identifier: 'Ticket Number',
  status: 'Ticket Status',
  sold_price: 'Sold Price',
  first_name: 'First Name (Ticket)',
  last_name: 'Last Name (Ticket)',
  email: 'Email (Ticket)',
  phone: 'Phone (Ticket)',
  invoice_id: 'Invoice ID',
  payment_status: 'Payment Status',
  is_sent_by_email: 'Sent by Email',
  is_sent_by_sms: 'Sent by SMS',
};

export default event_tickets;
